import { memo, useId } from 'react';
import { tokens } from '@optiaxiom/globals';
import { BaseEdge, EdgeProps, getSmoothStepPath, useInternalNode } from '@xyflow/react';

import { CustomMarkerEnd } from './CustomMarkerEnd';
import { getEdgeParams } from './utils';

export const CustomEdge = memo(({ id, source, target, style = {}, selected }: EdgeProps) => {
  const markerId = useId();
  const sourceNode = useInternalNode(source);
  const targetNode = useInternalNode(target);

  if (!sourceNode || !targetNode) {
    return null;
  }

  const { sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition } = getEdgeParams(
    sourceNode,
    targetNode
  );

  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const edgeColor = selected
    ? tokens.colors['border.accent']
    : style.stroke || tokens.colors['fg.avatar.purple'];

  return (
    <>
      <CustomMarkerEnd id={markerId} color={edgeColor} />
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={`url(#${markerId})`}
        style={{
          ...style,
          strokeWidth: selected ? 2 : 1,
          stroke: edgeColor,
        }}
      />
    </>
  );
});

CustomEdge.displayName = 'CustomEdge';
